module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAUVBMVEUAAAAt0pYn0I0mz48l0I4m0I0m0I4m0I4m0I4mz40lz40nz48mz41V/6olz44wz48lz40mz46T58aR5sX///8m0I8m0I7I8uLJ8+Im0I3H8uFAMToxAAAAGnRSTlMAEVyhv9nzUb77/zvFA5AQutb///9dov//8pCdJsMAAADPSURBVHgBjZQFlsAgDAU/dS/Odu9/z1Xoo5rMkwqDJ0GOKMqqbpq6KguBe9quH3b6rr1Rxmk4MY04Mi/DDcuMjFUOt8g1c9TwgNqtWQ6PyDTjcT1aH9cV9zXkGGuP1v8ep3dpwg/t8C4NLYCOkjpA9JTUC7iBkgYHT0seFS1VqNMZRoK1H/E1yTWaNMAN0Wqw0dK2T2cin9aG9J6m4y28pKWSc5gF71pYF8wLFTro2OGL5WiZYyLwU4pOTn6a0wWDXXqIInZEOP9fDr0TyPgG5EwvevVOSgoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ad.png
// module id = TqIw
// module chunks = 44